/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState ,useEffect } from 'react'
import Menu from '../../../../components/InternalMenu/Menu'

import ReactPaginate from 'react-paginate'

import { useNavigate } from 'react-router-dom'

import picIcon from '../../../../assets/svg/Pic.svg'
import Table from '../../../../components/InternalMenu/BannerList'

import { ToastContainer } from 'react-toastify'

import { get } from '../../../../services/http'

export default function index() {
  const navigate = useNavigate()
  document.title = 'بنرها'

  const [banners, setBanners] = useState([])
  const [bannersCount, setBannersCount] = useState()
  const [totalPage, setTotalPage] = useState()
  const [bannerStatus, setBannerStatus] = useState(false)

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/im/banners/create')
  }

  useEffect(() => {
    get(`/api/admin/im/banners?token=${token}`).then(response => {
      setBanners(response.data.data.docs)
      if (response.data.data.docs.length >= 1) {
        setBannerStatus(true)
      }
      setTotalPage(response.data.data.pages)
      setBannersCount(response.data.data.totalDocs)
    })
  }, [token])

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'banner'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={picIcon} width={'22px'} alt='resturantIcon' />
              </div>
              <div className='text'>
                بنرها
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler} style={bannerStatus ? { display: 'none' } : { }}>ساخت بنرها</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل بنرها
              </div>
              <div className="left">
                {bannersCount}3
              </div>
            </div>

            <Table data={banners} />
            <ReactPaginate
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={''}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
